import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Logo from "Assests/Icons/WebsiteLogo.png";
import "./Header.css";
import AuthenticationFlows from "Components/Login/AuthenticationFlows";
import { Dropdown } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { setCartDataAction, signout } from "../../Redux/Actions/set.action";
import {
  setAuthenticationModel,
  setContactModel,
} from "../../Redux/Actions/model";
import { toBeRequired } from "@testing-library/jest-dom/matchers";
import { setProfileActiveTab } from "../../Redux/Actions/profile";
import { useLocation } from "react-router-dom";
import ND from "Assests/Images/ND-small.webp";
import { setAlert } from "../../Redux/Actions/alert.action";

const Header = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const selectedTab = "header" + window.location.pathname;
  //const [loginModal, setLoginModal] = useState(false);
  const authToken = localStorage.getItem("access_token");
  const authModel = useSelector((state) => state?.setAuthModel);
  const contactModel = useSelector((state) => state?.setContactUsModel);
  const user = useSelector((state) => state?.setUserDataReducer);

  const testList = useSelector((state) => state.setCartDataReducer?.tests);
  const home = testList?.home ? testList?.home : [];
  const lab = testList?.lab ? testList?.lab : [];

  const location = useLocation();

  const scrollToSection = () => {
    const targetSection = document.getElementById("contactSection");

    if (targetSection) {
      targetSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      <div className="header">
        <div>
          <div className="logo-wrapper" onClick={() => navigate("/")}>
            {/* <img src={Logo} alt="logo" /> */}
            <img src={ND} alt="logo" />
          </div>

          {/* <div
            className="show-mobile"
            onClick={() => {
              navigate("/cart");
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="40"
              height="40"
              viewBox="0 0 24 24"
              fill="none"
              style={{ cursor: "pointer" }}
            >
              <path
                d="M8 21.75C8.9665 21.75 9.75 20.9665 9.75 20C9.75 19.0335 8.9665 18.25 8 18.25C7.0335 18.25 6.25 19.0335 6.25 20C6.25 20.9665 7.0335 21.75 8 21.75Z"
                fill="#2A364E"
              />
              <path
                d="M16 21.75C16.9665 21.75 17.75 20.9665 17.75 20C17.75 19.0335 16.9665 18.25 16 18.25C15.0335 18.25 14.25 19.0335 14.25 20C14.25 20.9665 15.0335 21.75 16 21.75Z"
                fill="#2A364E"
              />
              <path
                d="M19.17 5.84999C18.84 5.46999 18.36 5.24999 17.85 5.24999H6C6 5.24999 5.95 5.25999 5.93 5.25999L5.89 4.77999C5.78 3.35999 4.58 2.23999 3.15 2.23999H3C2.59 2.23999 2.25 2.57999 2.25 2.98999C2.25 3.39999 2.59 3.73999 3 3.73999H3.15C3.8 3.73999 4.35 4.24999 4.4 4.88999L5.05 13.27C5.2 15.21 6.84 16.73 8.79 16.73H18.01C18.42 16.73 18.76 16.39 18.76 15.98C18.76 15.57 18.42 15.23 18.01 15.23H8.78C7.81 15.23 6.98 14.6 6.67 13.73H15.4C17.25 13.73 18.85 12.35 19.11 10.51L19.58 7.22999C19.65 6.72999 19.5 6.21999 19.17 5.83999V5.84999ZM17.63 10.31C17.47 11.41 16.51 12.24 15.4 12.24H6.46L6.04 6.73999H17.85C17.95 6.73999 18.01 6.78999 18.04 6.82999C18.07 6.85999 18.11 6.92999 18.1 7.02999L17.63 10.31Z"
                fill="#2A364E"
              />
            </svg>
            {(home.length > 0 || lab.length > 0) && (
              <span style={{ padding: "10px" }}>
                {`${(home?.length || 0) + (lab?.length || 0)}`}
              </span>
            )}
          </div> */}

          <div className="list hide-mobile">
            <ul>
              <li
                className={(selectedTab === "header/" && "active").toString()}
                onClick={() => navigate("/")}
              >
                Home
              </li>
              <li
                className={(
                  selectedTab.includes("header/about-us") && "active"
                ).toString()}
                onClick={() => navigate("/about-us")}
              >
                About Us
              </li>

           
              {/*
              
              <li
                className={(
                  selectedTab.includes("header/doctor") && "active"
                ).toString()}
              onClick={() => navigate("/doctor")}
              >
                Doctor
                 <Dropdown>
                  <Dropdown.Toggle id="dropdown-doctor">Doctor</Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item href="#/action-1">NephroNed</Dropdown.Item>
                    <Dropdown.Item href="#/action-2">TbNed</Dropdown.Item>
                    <Dropdown.Item href="#/action-3">GastroNed</Dropdown.Item>
                    <Dropdown.Item href="#/action-3">GynaeNed</Dropdown.Item>
                    <Dropdown.Item href="#/action-3">OncoNed</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown> 
              </li>
              */}
              <li
                className={(
                  selectedTab.includes("header/corporate") && "active"
                ).toString()}
                onClick={() => navigate("/corporate")}
              >
                Corporate
                {/* <Dropdown>
                  <Dropdown.Toggle id="dropdown-doctor">
                    Corporate
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item
                      onClick={() => {
                        navigate("/corporate");
                      }}
                    >
                      Corporate
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() => {
                        navigate("/services/employment");
                      }}
                    >
                      Annual Physical Examination
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() => {
                        navigate("/services/employment");
                      }}
                    >
                      Wellness/Health Packages
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() => {
                        navigate("/services/employment");
                      }}
                    >
                      Pre-Employment Medical Examination
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown> */}
              </li>
              <li
                className={(
                  selectedTab.includes("header/HMOs") && "active"
                ).toString()}
                // onClick={() => navigate("/HMOs/step1")}
              >
                <Dropdown>
                  <Dropdown.Toggle id="dropdown-doctor">HMOs</Dropdown.Toggle>

                  <Dropdown.Menu>
                    {/* <Dropdown.Item href="#/action-1">
                      List of Accredited HMOs
                    </Dropdown.Item> */}
                    <Dropdown.Item
                      onClick={() => navigate("/HMOs/make-an-appointment")}
                    >
                      Online HMO Approval
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </li>
              
            </ul>
          </div>

          {/* <div className="signup hide-mobile">
            {Boolean(authToken) ? (
              <>
                <div
                  onClick={() => {
                    navigate("/cart");
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="40"
                    height="40"
                    viewBox="0 0 24 24"
                    fill="none"
                    style={{ cursor: "pointer" }}
                  >
                    <path
                      d="M8 21.75C8.9665 21.75 9.75 20.9665 9.75 20C9.75 19.0335 8.9665 18.25 8 18.25C7.0335 18.25 6.25 19.0335 6.25 20C6.25 20.9665 7.0335 21.75 8 21.75Z"
                      fill="#2A364E"
                    />
                    <path
                      d="M16 21.75C16.9665 21.75 17.75 20.9665 17.75 20C17.75 19.0335 16.9665 18.25 16 18.25C15.0335 18.25 14.25 19.0335 14.25 20C14.25 20.9665 15.0335 21.75 16 21.75Z"
                      fill="#2A364E"
                    />
                    <path
                      d="M19.17 5.84999C18.84 5.46999 18.36 5.24999 17.85 5.24999H6C6 5.24999 5.95 5.25999 5.93 5.25999L5.89 4.77999C5.78 3.35999 4.58 2.23999 3.15 2.23999H3C2.59 2.23999 2.25 2.57999 2.25 2.98999C2.25 3.39999 2.59 3.73999 3 3.73999H3.15C3.8 3.73999 4.35 4.24999 4.4 4.88999L5.05 13.27C5.2 15.21 6.84 16.73 8.79 16.73H18.01C18.42 16.73 18.76 16.39 18.76 15.98C18.76 15.57 18.42 15.23 18.01 15.23H8.78C7.81 15.23 6.98 14.6 6.67 13.73H15.4C17.25 13.73 18.85 12.35 19.11 10.51L19.58 7.22999C19.65 6.72999 19.5 6.21999 19.17 5.83999V5.84999ZM17.63 10.31C17.47 11.41 16.51 12.24 15.4 12.24H6.46L6.04 6.73999H17.85C17.95 6.73999 18.01 6.78999 18.04 6.82999C18.07 6.85999 18.11 6.92999 18.1 7.02999L17.63 10.31Z"
                      fill="#2A364E"
                    />
                  </svg>
                  {(home.length > 0 || lab.length > 0) && (
                    <span style={{ padding: "10px" }}>
                      {`${(home?.length || 0) + (lab?.length || 0)}`}
                    </span>
                  )}
                </div>

                <Dropdown className="profile-menu">
                  <Dropdown.Toggle id="dropdown-user">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M12.0018 11.75C12.9413 11.75 13.8596 11.4714 14.6408 10.9495C15.4219 10.4275 16.0307 9.6857 16.3902 8.81775C16.7498 7.9498 16.8438 6.99473 16.6605 6.07332C16.4773 5.15191 16.0249 4.30554 15.3606 3.64124C14.6963 2.97695 13.8499 2.52455 12.9285 2.34127C12.0071 2.15799 11.052 2.25206 10.1841 2.61157C9.31612 2.97109 8.57427 3.57991 8.05233 4.36104C7.5304 5.14218 7.25181 6.06054 7.25181 7C7.25181 8.25978 7.75226 9.46796 8.64306 10.3588C9.53385 11.2496 10.742 11.75 12.0018 11.75ZM12.0018 3.75C12.6446 3.75 13.273 3.94061 13.8074 4.29773C14.3419 4.65484 14.7584 5.16242 15.0044 5.75628C15.2504 6.35014 15.3148 7.00361 15.1894 7.63405C15.064 8.26448 14.7544 8.84358 14.2999 9.2981C13.8454 9.75262 13.2663 10.0622 12.6359 10.1876C12.0054 10.313 11.352 10.2486 10.7581 10.0026C10.1642 9.75663 9.65665 9.34006 9.29954 8.8056C8.94242 8.27115 8.75181 7.64279 8.75181 7C8.75445 6.13886 9.09771 5.31374 9.70663 4.70482C10.3156 4.0959 11.1407 3.75264 12.0018 3.75ZM20.0018 14.76C14.855 12.7655 9.14867 12.7655 4.00181 14.76C3.48593 14.9592 3.04302 15.311 2.73215 15.7684C2.42128 16.2257 2.25721 16.767 2.26181 17.32V19C2.26181 19.7276 2.55017 20.4256 3.06373 20.941C3.57729 21.4565 4.2742 21.7474 5.00181 21.75H19.0018C19.7312 21.75 20.4306 21.4603 20.9464 20.9445C21.4621 20.4288 21.7518 19.7293 21.7518 19V17.32C21.7556 16.7658 21.5901 16.2237 21.2774 15.7662C20.9646 15.3087 20.5196 14.9576 20.0018 14.76ZM20.2518 19C20.2518 19.3315 20.1201 19.6495 19.8857 19.8839C19.6513 20.1183 19.3333 20.25 19.0018 20.25H5.00181C4.67029 20.25 4.35235 20.1183 4.11793 19.8839C3.88351 19.6495 3.75181 19.3315 3.75181 19V17.32C3.74949 17.0692 3.82393 16.8236 3.96513 16.6163C4.10633 16.4089 4.30756 16.2497 4.54181 16.16C9.33749 14.28 14.6661 14.28 19.4618 16.16C19.6961 16.2497 19.8973 16.4089 20.0385 16.6163C20.1797 16.8236 20.2541 17.0692 20.2518 17.32V19Z"
                        fill="white"
                      />
                    </svg>
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item
                      onClick={() => {
                        navigate("/profile");
                      }}
                    >
                      Profile
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() => {
                        dispatch(signout());
                        dispatch(setAlert("success", "Sign Out Successfully!"));
                      }}
                    >
                      Sign Out
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </>
            ) : (
              <>                
              </>
            )}
          </div> */}

          <div className="mobile-header show-mobile">
            <Dropdown align={{ lg: "start" }}>
              <Dropdown.Toggle id="dropdown-user">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M4 6H20M4 12H20M4 18H20"
                    stroke="#2A364E"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item onClick={() => navigate("/")}>
                  Home
                </Dropdown.Item>

                <Dropdown.Item onClick={() => navigate("/about-us")}>
                  About Us
                </Dropdown.Item>

                {/* <Dropdown align={{ lg: "start" }}>
                  <Dropdown.Toggle id="dropdown-services">
                    Services
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item
                      onClick={() => {
                        navigate("/services/all-test-package");
                      }}
                    >
                      All Tests & packages
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() => navigate("/services/diagnostics")}
                    >
                      Diagnostics
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() => navigate("/services/consultation")}
                    >
                      Consultation
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() => {
                        navigate("/services/radiology");
                      }}
                    >
                      Radiology
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() => {
                        navigate("/services/wellness-packages");
                      }}
                    >
                      Wellness Packages
                    </Dropdown.Item>
                   
                    
                  </Dropdown.Menu>
                </Dropdown> */}

                {/* <Dropdown.Item>Doctor</Dropdown.Item> */}

                <Dropdown.Item onClick={() => navigate("/corporate")}>
                  Corporate
                </Dropdown.Item>

                {/* <Dropdown align={{ lg: "start" }}>
                  <Dropdown.Toggle id="dropdown-doctor">Doctor</Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item href="#/action-1">NephroNed</Dropdown.Item>
                    <Dropdown.Item href="#/action-2">TbNed</Dropdown.Item>
                    <Dropdown.Item href="#/action-3">GastroNed</Dropdown.Item>
                    <Dropdown.Item href="#/action-3">GynaeNed</Dropdown.Item>
                    <Dropdown.Item href="#/action-3">OncoNed</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown> */}

                {/* <Dropdown align={{ lg: "start" }}>
                  <Dropdown.Toggle id="dropdown-doctor">
                    Corporate
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item href="#/action-1">
                      Annual Physical Examination
                    </Dropdown.Item>
                    <Dropdown.Item href="#/action-2">
                      Wellness/Health Packages
                    </Dropdown.Item>
                    <Dropdown.Item href="#/action-3">
                      Pre-Employment Medical Examination
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown> */}

                <Dropdown align={{ lg: "start" }}>
                  <Dropdown.Toggle id="dropdown-doctor">HMOs</Dropdown.Toggle>

                  <Dropdown.Menu>
                    {/* <Dropdown.Item>List of Accredited HMOs</Dropdown.Item> */}
                    <Dropdown.Item
                      onClick={() => navigate("/HMOs/make-an-appointment")}
                    >
                      Online HMO Approval
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>

                {/* <Dropdown.Item onClick={() => navigate("/partner-with-us")}>
                  Partner with us
                </Dropdown.Item> */}

                {/* <Dropdown align={{ lg: "start" }}>
                  <Dropdown.Toggle id="dropdown-doctor">
                    Partner with us
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item href="#/action-1">
                      Collection Center
                    </Dropdown.Item>
                    <Dropdown.Item href="#/action-2">
                      Hospital Lab Management
                    </Dropdown.Item>
                    <Dropdown.Item href="#/action-3">
                      Organise Camps
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown> */}

                {/* <Dropdown.Item onClick={() => navigate("/career")}>
                  Career
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => {
                    navigate("/profile");
                  }}
                >
                  Profile
                </Dropdown.Item> */}

                {/* <Dropdown.Item onClick={() => navigate("/cart")}>
                  Cart
                </Dropdown.Item> */}
                {/* {Boolean(authToken) ? (
                  <Dropdown.Item
                    onClick={() => {
                      dispatch(signout());
                      dispatch(setAlert("success", "Sign Out Successfully!"));
                    }}
                  >
                    Sign Out
                  </Dropdown.Item>
                ) : (
                  <Dropdown.Item
                    onClick={() => dispatch(setAuthenticationModel(true))}
                  >
                    Log In
                  </Dropdown.Item>
                )} */}

                {/* <Dropdown.Item
                  onClick={() => {
                    dispatch(signout());
                    dispatch(setAlert("success", "Sign Out Successfully!"));
                  }}
                >
                  Sign Out
                </Dropdown.Item> */}
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>

        <div className="banner-upper">
          <div className="float-section">
           
            
          </div>
        </div>
      </div>
      {/* {getModals()} */}
    </>
  );
};

export default Header;
